import axios from 'axios';

/**
 * Save (create or update) a flow.
 * If id is provided the server will update the existing record if it belongs to the user.
 */
export async function saveFlow({ id, graph, name, role, humanAuthored = true, autoSaved = false }) {
  const { data } = await axios.post('/api/v1/flows', {
    id: id || undefined,
    graph,
    name: name || undefined,
    role: role || undefined,
    human_authored: humanAuthored,
    auto_saved: autoSaved,
  });
  return data;
}

/**
 * Patch an existing flow (update graph data + metadata).
 */
export async function updateFlow(id, { graph, name, role, humanAuthored, autoSaved }) {
  const { data } = await axios.patch(`/api/v1/flows/${id}`, {
    graph,
    name: name || undefined,
    role: role || undefined,
    human_authored: humanAuthored ?? true,
    auto_saved: autoSaved ?? false,
  });
  return data;
}

/**
 * List all flows for the authenticated user (newest first).
 */
export async function listFlows() {
  const { data } = await axios.get('/api/v1/flows');
  return data; // array of FlowListItem
}

/**
 * Load a single flow by ID (includes full graph data).
 */
export async function getFlow(id) {
  const { data } = await axios.get(`/api/v1/flows/${id}`);
  return data;
}

/**
 * Delete a flow.
 */
export async function deleteFlow(id) {
  const { data } = await axios.delete(`/api/v1/flows/${id}`);
  return data;
}
